import CircularProgress from "@mui/material/CircularProgress";
import { useHistory, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
export default function MicroSoftVerify(props) {
  const { status, message } = props.match.params;
  const locData = useLocation();
  const [showToast, setShowToast] = useState(false);
  const history = useHistory();
  useEffect(() => {
    //console.log("Authorization==========>", status, message);
    // console.log("Authorization==========>", status.toString() === "true");
    if (status.toString() === "true") {
      setShowToast(true);
      toast.success(message.replace(/-/g, ' '), {
        autoClose: true,
        position: "top-right",
        duration: 3000,
      });
      setTimeout(() => {
        history.push("/Email/accounts");
      }, 3000);
    }
    else
    {
      setShowToast(true);
      toast.error(message.replace(/-/g, ' '), {
        autoClose: true,
        position: "top-right",
        duration: 3000,
      });
      setTimeout(() => {
        history.push("/Email/accounts");
      }, 3000);
    }
 
  }, [locData.search]);
  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress
        size={60}
        style={{
          color: "#1C485F",
        }}
      />
      {showToast && <ToastContainer />}
    </div>
  );
}
